import { FormControl as MUIFormControl } from '@mui/material';

const FormControl = MUIFormControl;

export default FormControl;
